const renderTeachersModal = () => {
   const pageBody = document.querySelector('body');
   const teachersModal = document.querySelector('.teachers__modal');
   const modalTitle = teachersModal?.querySelector('h3');
   const modalDescription = teachersModal?.querySelector('.teachers__modal-description');
   const modalImage = teachersModal?.querySelector('.teachers__modal-img img');
   const modalFeatures = teachersModal?.querySelector('.teachers__modal-features');

   const onCardClick = (evt) => {
      if (evt.target.closest('[data-modal-id="teachers-modal"]')) {
         const targetCard = evt.target.closest('.teachers__item');
         const cardName = targetCard.querySelector('h5').textContent;
         const cardDescription = targetCard.querySelector('p').textContent;
         const cardImage = targetCard.querySelector('img');
         const cardfeaturesList = targetCard.querySelector('.teachers__item-features');

         modalTitle.textContent = cardName;
         modalDescription.textContent = cardDescription;
         modalImage.src = cardImage.src;
         modalImage.alt = cardImage.alt;
         if (cardfeaturesList) {
            const features = cardfeaturesList && Array.from(cardfeaturesList.querySelectorAll('li')).map((feature) => feature.outerHTML); 
            modalFeatures.innerHTML = features.join(' ');
         };
      }
   };

   teachersModal && pageBody.addEventListener('click', onCardClick);
};

export default renderTeachersModal;
